import http from "src/services/http";
import queryString from "query-string";
import dayjs from "dayjs";
import store from "src/store";
import * as types from "../types/pedidos";

export const loadItemsPedido = (pedido_id) => {
  return (dispatch) => {
    http
      .get(`/api/v2/empresa/pedidos/listar_items_app?pedido_id=${pedido_id}`)
      .then(
        (response) => {
          dispatch([{ type: types.SET_ITEMS, payload: response.data }]);
        },
        (e) => {
          dispatch([{ type: types.SET_ITEMS, payload: [] }]);
        }
      );
  };
};

export const pesquisarPedidos = (tab) => {
  const { filtro } = store.getState().pedidos;
  filtro.status = tab;

  filtro.data_final = dayjs(filtro.data_final).format("YYYY-MM-DD");
  filtro.data_inicio = dayjs(filtro.data_inicio).format("YYYY-MM-DD");
  const qry = queryString.stringify(filtro, { arrayFormat: "index" });
  return (dispatch) => {
    http.get(`/api/v2/empresa/pedidos/listar?${qry}`).then(
      (response) => {
        const {
          total,
          data,
          current_page: page,
          per_page: perpage,
        } = response.data;
        dispatch([
          { type: types.SET_LIST, payload: data },
          { type: types.SET_TOTAL, payload: total },
          { type: types.SET_PAGE, payload: page },
          { type: types.SET_PERPAGE, payload: perpage },
          { type: types.SET_LOADING, payload: false },
        ]);
      },
      (error) => {
        dispatch([{ type: types.SET_LOADING, payload: false }]);
      }
    );
  };
};

export const pesquisarPedidosResumo = (filtro) => {
  const qry = queryString.stringify(filtro, { arrayFormat: "index" });
  return (dispatch) => {
    http.get(`/api/v2/empresa/pedidos/resumo?${qry}`).then(
      (response) => {
        dispatch([{ type: types.SET_QTDE_STATUS, payload: response.data }]);
      },
      (error) => {
        console.log(error);
      }
    );
  };
};

export const executaAceite = (pedido_id) => {
  return new Promise((resolve, reject) => {
    http.put(`/api/v2/empresa/pedidos/executar_aceite/${pedido_id}`, {}).then(
      () => resolve(),
      (error) => reject(error)
    );
  });
};

export const executaEmPreparo = (pedido_id) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/api/v2/empresa/pedidos/executar_em_preparo/${pedido_id}`, {})
      .then(
        () => resolve(),
        (error) => reject(error)
      );
  });
};

export const executaSaiuEntrega = (pedido_id, entregador_id) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/api/v2/empresa/pedidos/executar_saiu_entrega/${pedido_id}`, {
        entregador_id,
      })
      .then(
        () => resolve(),
        (error) => reject(error)
      );
  });
};

export const executaEnviarEntrega = (pedido_id) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/api/v2/empresa/pedidos/executar_enviar_entrega/${pedido_id}`, {})
      .then(
        () => resolve(),
        (error) => reject(error)
      );
  });
};

export const executaFinalizarEntrega = (pedido_id) => {
  return new Promise((resolve, reject) => {
    http.put(`/api/v2/empresa/pedidos/confirmar_entrega/${pedido_id}`, {}).then(
      () => resolve(),
      (error) => reject(error)
    );
  });
};

export const executaCancelarPedido = (pedido_id) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/api/v2/empresa/pedidos/cancelar_pedido/${pedido_id}`, {})
      .then(
        () => resolve(),
        (error) => reject(error)
      );
  });
};

export const pesquisarEntregadores = (filtro) => {
  const qry = queryString.stringify(filtro, { arrayFormat: "index" });
  store.dispatch({ type: types.SET_LOADING, payload: true });
  return (dispatch) => {
    http.get(`/api/v2/empresa/entregadores?${qry}`).then(
      (response) => {
        const { data } = response.data;
        dispatch([
          // { type: types.SET_ENTREGADORES_TOTAL, payload: total },
          { type: types.SET_ENTREGADORES, payload: data },
          { type: types.SET_LOADING, payload: false },
        ]);
      },
      (_) => {
        dispatch([{ type: types.SET_LOADING, payload: false }]);
      }
    );
  };
};
